import Favorite from 'components/organisms/Profile/Favorite';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
	actionCreators as favoritesAC,
	getFavorites,
	getTotalFavoriteCount,
	getTotalFavoriteCountWithDynamicProducts,
} from 'store/favorites';

const mapStateToProps = (state) => ({
	favorites: getFavorites(state),
	favoritesLength: getTotalFavoriteCount(state),
	totalFavoritesLength: getTotalFavoriteCountWithDynamicProducts(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doLoadFavorites: favoritesAC.doLoadFavorites,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(Favorite as any);
